// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__JSWpx marketplaceSmallFontStyles","symbol":"Tooltip_symbol__FlC8j","tooltip":"Tooltip_tooltip__lKrqH"};